<template>
  <div class="wrapper detail">
    <div class="level-header detail-header">
      <div class="level__counter">5.</div>
      <div class="level__title detail__title">
        ДЕТАЛИ ДОМА
      </div>
    </div>

    <div class="detail-task detail-zone dropArea">
      <div class="explain-wrapper detail-explain-area">
        <div class="explain detail-explain platband">
          <div class="explain__title">Наличник</div>
          <div class="explain__desc">Декоративное оформление оконного/дверного проёма накладными
            фигурными профилированными деревянными планками. Обильно украшен резьбой резной
            наличник. Прикрывает щель между стеной и оконной/дверной коробкой
          </div>
          <div class="explain-line">
            <svg width="292" height="369" viewBox="0 0 292 369" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M271 1V0H270.494L270.194 0.407589L271 1ZM0.694364 366.908C0.367185 367.353 0.462648 367.978 0.907589 368.306C1.35253 368.633 1.97846 368.537 2.30564 368.092L0.694364 366.908ZM292 0H271V2H292V0ZM270.194 0.407589L0.694364 366.908L2.30564 368.092L271.806 1.59241L270.194 0.407589Z"
                fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain detail-explain stream">
          <div class="explain__title">Поток</div>
          <div class="explain__desc">
            Бревно с выдолбленным желобом для отвода воды с кровли. Одновременно поток является
            опорой для нижних концов кровельного теса
          </div>
          <div class="explain-line">
            <svg width="96" height="186" viewBox="0 0 96 186" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M74.8966 1V0H74.2212L73.9689 0.626446L74.8966 1ZM0.0723914 184.126C-0.133916 184.639 0.114142 185.221 0.626446 185.428C1.13875 185.634 1.7213 185.386 1.92761 184.874L0.0723914 184.126ZM96 0H74.8966V2H96V0ZM73.9689 0.626446L0.0723914 184.126L1.92761 184.874L75.8242 1.37355L73.9689 0.626446Z"
                fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain detail-explain shelom">
          <div class="explain__title">Шелом</div>
          <div class="explain__desc">
            Бревно с выбранным снизу пазом. Прикрывает верхний (коньковый) стык тесин деревянной
            кровли. Комлевой частью выходит на фасад дома и украшается резным изображением коня или
            птицы
          </div>
          <div class="explain-line">
            <svg width="279" height="138" viewBox="0 0 279 138" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M264.359 1V0H264.116L263.9 0.11148L264.359 1ZM0.541163 136.111C0.0504466 136.365 -0.141929 136.968 0.11148 137.459C0.364888 137.95 0.968121 138.142 1.45884 137.889L0.541163 136.111ZM279 0H264.359V2H279V0ZM263.9 0.11148L0.541163 136.111L1.45884 137.889L264.818 1.88852L263.9 0.11148Z"
                fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain detail-explain prichelina">
          <div class="explain__title">Причелина</div>
          <div class="explain__desc">
            Резная доска, прикрывающая торец двускатной тесовой крыши. В резьбе использовались
            солярные символы, волновые элементы, кресты. Орнамент указывал на связь дома с верхним
            миром и защищал от негативного влияния небесных явлений
          </div>
          <div class="explain-line">
            <svg width="222" height="170" viewBox="0 0 222 170" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M69.2776 1V0H69.7229L70.0209 0.330981L69.2776 1ZM221.243 168.331C221.613 168.741 221.58 169.374 221.169 169.743C220.759 170.113 220.126 170.079 219.757 169.669L221.243 168.331ZM0 0H69.2776V2H0V0ZM70.0209 0.330981L221.243 168.331L219.757 169.669L68.5344 1.66902L70.0209 0.330981Z"
                fill="black"/>
            </svg>

          </div>
        </div>
        <div class="explain detail-explain towel">
          <div class="explain__title">Полотенце</div>
          <div class="explain__desc">
            Короткая, обычно резная вертикальная доска, прикрывающая стык причелин
          </div>
          <div class="explain-line">
            <svg width="110" height="203" viewBox="0 0 110 203" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.5 1V0H22.1547L22.4165 0.600021L21.5 1ZM109.917 201.1C110.137 201.606 109.906 202.196 109.4 202.417C108.894 202.637 108.304 202.406 108.083 201.9L109.917 201.1ZM0 0H21.5V2H0V0ZM22.4165 0.600021L109.917 201.1L108.083 201.9L20.5835 1.39998L22.4165 0.600021Z"
                fill="black"/>
            </svg>

          </div>
        </div>
        <div class="explain detail-explain baluster">
          <div class="explain__title">Балясник</div>
          <div class="explain__desc">
            Невысокие фигурные столбики в виде колонн (иногда с резным декором), поддерживающие
            поручни перил ограждений балконов, лестниц и т.д.
          </div>
          <div class="explain-line">
            <svg width="164" height="53" viewBox="0 0 164 53" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M46.361 1V0H46.5709L46.763 0.0843912L46.361 1ZM162.902 51.0844C163.408 51.3064 163.638 51.8964 163.416 52.4021C163.194 52.9077 162.604 53.1377 162.098 52.9156L162.902 51.0844ZM0 0H46.361V2H0V0ZM46.763 0.0843912L162.902 51.0844L162.098 52.9156L45.9589 1.91561L46.763 0.0843912Z"
                fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain detail-explain magpie">
          <div class="explain__title">Сорока</div>
          <div class="explain__desc">
            Шпонка-стяжка, скрепляющая коневую слегу и охлупень
          </div>
          <div class="explain-line">
            <svg width="67" height="131" viewBox="0 0 67 131" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20.2626 1V0H19.4023L19.2738 0.850616L20.2626 1ZM0.0112208 128.351C-0.0712817 128.897 0.304528 129.406 0.850616 129.489C1.3967 129.571 1.90628 129.195 1.98878 128.649L0.0112208 128.351ZM60.5 0H20.2626V2H60.5V0ZM19.2738 0.850616L0.0112208 128.351L1.98878 128.649L21.2514 1.14938L19.2738 0.850616Z"
                fill="black"/>
              <path
                d="M65.0574 130.334C65.2417 130.854 65.8132 131.127 66.3338 130.943C66.8544 130.758 67.127 130.187 66.9426 129.666L65.0574 130.334ZM19.5573 1.83378L65.0574 130.334L66.9426 129.666L21.4427 1.16622L19.5573 1.83378Z"
                fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain detail-explain bull">
          <div class="explain__title">Бык</div>
          <div class="explain__desc">
            Наклонные массивные бревна, поддерживающие второй этаж хозяйственной части
          </div>
          <div class="explain-line">
            <svg width="151" height="88" viewBox="0 0 151 88" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M125 1V0H124.687L124.43 0.178284L125 1ZM0.430099 86.1783C-0.0237122 86.493 -0.136459 87.1161 0.178284 87.5699C0.493027 88.0237 1.11607 88.1365 1.5699 87.8217L0.430099 86.1783ZM151 0H125V2H151V0ZM124.43 0.178284L0.430099 86.1783L1.5699 87.8217L125.57 1.82172L124.43 0.178284Z"
                fill="black"/>
            </svg>
          </div>
        </div>
      </div>
      <div v-for="task in tasks"
           :key="task.id"
           :class="task"
           :data-compare="task"
           class="detail__drop dropzone">
        <div class="queryMark">
          ?
        </div>
      </div>
    </div>
    <div class="detail-answers dropzone draggable-dropzone--occupied dragArea">
      <div v-for="answer in answers"
           v-bind:key="answer.name"
           :class="[answer.name]"
           :data-compare="answer.name"
           :data-equally="answer.equally"
           :hasPoint="answer.hasPoint"
           class="answer isDraggable">
        <div>
          <div class="answer__name">
            {{ answer.caption }}
          </div>
        </div>

      </div>
    </div>
    <div class="task-block">
      <div class="task-block__title">
        Сопоставьте название и деталь на рисунке
      </div>
      <div class="task-block__caption">
        Перетащите мышью кнопки элементов в соответствующие слоты на картинке здания
      </div>
    </div>
    <transition name="fade"
                :duration="400">
      <div class="finished-wrapper"
           v-if="levelFinished">
        <div class="finished__caption">Отлично!</div>
        <button v-if="levelFinished"
                @click="$emit('next-level', 'elements')"
                class="levelControl next-level">
          продолжить
        </button>
      </div>
    </transition>
    <footer class="footer">
      <div class="footer__logo">
        <img src="../img/kizhi_logo.png" alt="">
      </div>
      <div class="footer__copyright">
        © 2019 Государственный историко-архитектурный и этнографический музей-заповедник «Кижи»
      </div>
    </footer>
    <!--Core components-->
    <level-core :tasks="tasks"
                :answers="answers"
                :explanation="'explain'"
                :answerOffset="[-12, 20]"
                @level-finished="onLevelFinished"
                @calculate-points="$emit('calculate-points', $event)"
    ></level-core>
  </div>
</template>

<script>
    /* eslint-disable indent */

    import {Droppable} from '@shopify/draggable';
    import levelCore from './level-сore.vue';

    export default {
        components: {
            levelCore,
        },
        data() {
            return {
                levelPoints: 0,
                levelFinished: false,
                tasks: ['platband', 'stream', 'shelom', 'prichelina', 'towel', 'baluster', 'magpie', 'bull',
                ],
                answers: [
                    {name: 'platband', caption: 'Наличник', hasPoint: true},
                    {name: 'stream', caption: 'Поток', hasPoint: true},
                    {name: 'shelom', caption: 'Шелом', hasPoint: true},
                    {name: 'prichelina', caption: 'Причелина', hasPoint: true},
                    {name: 'towel', caption: 'Полотенце', hasPoint: true},
                    {name: 'baluster', caption: 'Балясник', hasPoint: true},
                    {name: 'magpie', caption: 'Сорока', hasPoint: true},
                    {name: 'bull', caption: 'Бык', hasPoint: true},
                ],
            };
        },
        methods: {
            onLevelFinished(result) {
                this.levelFinished = result;
            },
        },
        watch: {},
        computed: {},
        updated() {
        },
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>


При сборке не обошлось без сложностей. Болты не качественные, и быстро срывается резьба. Но если не торопиться и закручивать болты по диагонали с обоих сторон,
или собирать его в двоем, то будет легче. Газлифт не самый качественный, через полгода начинает поскрипывать,
но в целом за свою цену работает отлично, главное вовремя смазывать.
Механизм покачивания отличный. Колесики спустя почти год отлично ездят, не застревают. Подлокотники хоть и кажутся большими, но на деле отлично подходят под стандартный стол.
